/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Job_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to submit shot description job." |
*
* @param {Scene_Description_Job_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_job_failed = /** @type {((inputs?: Scene_Description_Job_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Job_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la soumission de la description de la prise de vue.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Einreichen der Shot-Beschreibung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile inviare la descrizione dell'inquadratura.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось отправить описание задания.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo enviar la descripción del trabajo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提交镜头描述工作失败。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("撮影内容の説明を送信できませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट विवरण जमा करने का कार्य विफल रहा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível enviar a descrição da cena.")
	return /** @type {LocalizedString} */ ("Failed to submit shot description job.")
});